import { useContext } from 'react';
import { CameraSourceMasterContext } from '../contexts/CameraSourceContext';
export const useCameraSource = () => {
    const state = useContext(CameraSourceMasterContext);
    if (!state) {
        throw new Error('useCameraSource must be used inside of a CameraSourceContext');
    }
    return state;
};
